import template from './companies_component.html';
import tr from '../../lib/default-translator.js';

class AdminCompaniesComponentViewModel
{
	constructor(bindings)
	{
		this.bindings = bindings;
		this.companies = ko.observableArray();
		this.departments = ko.observableArray();
		this.editing = ko.observable(false);

		// bind functions to use this 'this'
		this.save_company = this.save_company.bind(this);
		this.delete_company = this.delete_company.bind(this);

		// PAGE LOAD
		this.updateData();
	}

	async updateData()
	{
		try {
			let options = {
				table: 'v_department_company',
				schema: 'savanna'
			}

			let res = await Grape.fetches.getJSON('/api/record', options);
			if (res.status == 'OK')
			{
				if (res.records)
					this.departments(res.records);
			}
			else
				Grape.alerts.apiError(res);
				
		} catch (error) {
			Grape.alerts.alert({ type: 'error', title: 'Error', message: error.message });
			console.error(error)
		}

		try {
			let options = {
				table: 'company',
				schema: 'public'
			}

			let res = await Grape.fetches.getJSON('/api/record', options);
			if (res.status == 'OK')
			{
				if (res.records)
					this.companies(res.records);
			}
			else
				Grape.alerts.apiError(res);

		} catch(error)
		{
			Grape.alerts.alert({ type: 'error', title: 'Error', message: error.message });
			console.error(error)
		}
		this.editing(false);
	};

	edit_company(v, e)
	{
		let view_row = $(e.currentTarget).parent().parent().parent();
		let edit_row = $(e.currentTarget).parent().parent().parent().next();
		view_row.hide();
		edit_row.show();
		this.editing(true);
	};

	async delete_company(v, e)
	{
		let edit_row = $(e.currentTarget).parent().parent().parent();
		let data = ko.mapping.toJS(v);

		let response = await Grape.alerts.confirm({ type: 'warning', title: tr('Warning'), message: tr('Are you sure you want to delete this company entry ? NOTE: All departments linked to this company will also be deleted. ') });

		if (response)
		{
			let res = await Grape.fetches.postJSON('/admin/companies/delete', data);
			if (res.status == 'OK')
			{
				Grape.alerts.alert({ type: 'success', message: tr('Successfully deleted company.'), title: tr('Success')});
				this.updateData();
				edit_row.hide();
			}
			else if (res.status == 'ERROR')
				Grape.alerts.apiError(res);
			else
				Grape.alerts.alert({ type: 'error', message: tr('Something went wrong...'), title: tr('Error')});
		}
	};

	async save_company(v, e)
	{
		let view_row = $(e.currentTarget).parent().parent().prev();
		let edit_row = $(e.currentTarget).parent().parent();
		let data = ko.mapping.toJS(v);

		if (data.company_id == '')
			data.company_id = null;

		let res = await Grape.fetches.postJSON('/admin/companies/edit', data);
		if (res.status == 'OK')
		{
			await Grape.alerts.alert({type: 'success', message: tr('Successfully saved company.'), title: tr('Success')});
			edit_row.hide();
			this.updateData();
			view_row.show();
		}
		else if (res.status == 'ERROR')
			Grape.alerts.apiError(res);
		else
		{
			Grape.alerts.alert({ type: 'error', message: res.error, 'title': tr('Error') });
			this.updateData();
			view_row.show();
			edit_row.hide();
		}
	};

	add_company(v, e)
	{
		let companies = v.companies;

		companies.unshift({ 'company': '', 'company_id': '' });
		let row = $('#company_body > tr:first-child');

		row.hide();
		row.next().show();
		this.editing(true);
	}

	cancel_save_company(v, e)
	{
		let view_row = $(e.currentTarget).parent().parent().prev();
		let edit_row = $(e.currentTarget).parent().parent();
		view_row.show();
		edit_row.hide();
		this.updateData();
	}
}

export default {
	name: 'companies_component',
	viewModel: AdminCompaniesComponentViewModel,
	module_type: 'ko',
	template: template,
	template_filename: 'translation/components/companies_component'
};
